module.exports = __webpack_public_path__ + "img/低碳声明.35f02aa5.png";